import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from "react-select";
import { Form } from 'react-bootstrap';
import _ from 'lodash'
import { css } from 'glamor'
const colors = {
  red: "#cc0000",
  green: "#198c19",
}
const noop = () => {

}
const ITEM_HEIGHT = 48;
const customStyles = {
  control: () => ({
    display: "flex",
    alignItems: "center",
    border: 0,
    height: "auto",
    background: "transparent",
    "&:hover": {
      boxShadow: "none"
    }
  }),
  menu: () => ({
    backgroundColor: "white",
    boxShadow: "1px 2px 6px #888888", // should be changed as material-ui
    position: "absolute",
    left: 0,
    top: `calc(100% + 1px)`,
    width: "100%",
    zIndex: 2,
    maxHeight: ITEM_HEIGHT * 4.5
  }),
  menuList: () => ({
    maxHeight: ITEM_HEIGHT * 4.5,
    overflowY: "auto"
  })
};
const styles = {
  placeholder: (base, state) => ({
    ...base,
    display:
      state.isFocused || state.isSelected || state.selectProps.inputValue
        ? 'none'
        : 'block',
  }),
}


/**
 *
 */
const styleMaterial = {
  borderRight: "none",
  borderLeft: "none",
  borderTop: "none",
  // borderBottom: "none",
  borderRadius: 0,
  minHeight: 34,
  "&:hover": {
    boxShadow: "none",
  },
  "&:focus": {
    boxShadow: "none"
  }
}

interface ErrorValidateT {
  msg: string
  show: boolean
  status: boolean
}

export type IInputSelectProps = {
  allNull?: boolean
  isMulti?: boolean
  className?: string
  validated?: boolean
  textFeedBack?: string
  required?: boolean
  disabled?: boolean
  placeholder?: string
  styleMaterial?: boolean
  value?: any
  onChangeValue(value): void
  is2D?: boolean
  style?: any
  data?: Array<any>
  selectedValue?:any
}

const InputSelect: React.FC<IInputSelectProps> = (props) => {

  const [error, setError] = React.useState<ErrorValidateT>({
    msg: "",
    show: false,
    status: null,
  });
  const [selected, setSelected] = React.useState(null);
  const [validated, setValidated] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const selectRef = React.useRef(null)


  React.useEffect(() => {
    updateComponent(props)
  }, []);

  React.useEffect(() => {
    componentWillReceiveProps(props)

  }, [props]);
  // componentWillMount() {
  //     this.updateComponent(this.props)
  // }
  const componentWillReceiveProps = (nextProps) => {
    if (selectedValue != nextProps.selectedValue && !_.isEmpty(nextProps.selectedValue)) {
      // console.log("selectedValue", nextProps.selectedValue)

      updateComponent(nextProps)
    }

    // validated when submite
    if (nextProps.validated != undefined && nextProps.validated == true && validated == false) {

      setValidated(true)
      checkValidity()
    }
  }



  const updateComponent = (nextProps) => {
    const { data, selectedValue, isMulti, is2D } = nextProps
    // set selectedValue then use when check is updated
    setSelectedValue(props.selectedValue)
    // this.setState({ selectedValue: selectedValue })

    if (props.is2D) {
      setOptions(data)
      setSelected(selectedValue)
      // this.setState({ options: data, selected: selectedValue })
      return true;
    }
    let varSelected = null;

    if (data && data.length > 0) {
      let newOptions = data.map((key) => {
        let val = { label: key, value: key }
        if (checkValue(selectedValue, key)) {
          if (props.isMulti) {
            varSelected = varSelected == null ? [] : varSelected
            varSelected.push(val)
          } else {
            varSelected = val
          }

        }
        return val
      })

      if (!props.allNull && !selected) {
        varSelected = newOptions[0]
      }
      setOptions(newOptions)
      setSelected(varSelected)

    }
  }


  const checkValue = (selectedValue, key) => {
    if (props.isMulti && selectedValue) {
      if (Object.keys(selectedValue).find((x, index) => selectedValue[index].value == key)) {
        return true
      }
    }
    if (selectedValue && selectedValue == key) {
      return true;
    }
    return false;
  }


  const onChange = (selected) => {
    setSelected(selected)
    checkValidity()
    // this.setState({ selected: selected }, () => {
    //   checkValidity()
    // })

    if (props.onChangeValue) {

      props.onChangeValue(props.isMulti || props.is2D ? selected : selected.value)
    }
  }


  const checkValidity = () => {
    let err = validation(selected)
    setError(err)

  }
  const validation = (selected): ErrorValidateT => {
    const { is2D, } = props

    let varError: ErrorValidateT = {
      msg: "",
      show: false,
      status: false,
    }

    if (props.required) {
      if (props.isMulti) {

        if (!selected || selected.length <= 0) {
          varError.show = true;
          varError.msg = props.textFeedBack
          return varError
        }
      } else {
        let value = is2D ? selected && selected.value : selected
        if (props.required && (value == "" || value == null || value == undefined)) {
          varError.show = true;
          varError.msg = props.textFeedBack
          return varError
        }
      }
    }
    return varError
  }
  const renderError = () => {

    if (error.show) {
      return (
        <Form.Text className="" style={{ color: error.status ? colors.green : colors.red }}>
          {error.msg}
        </Form.Text>
      )
    }
  }




  const { is2D } = props
  let className = ` ${props.className}`
  const value = is2D ? selected && selected.value : selected
  const { style } = props
  const customStyles = props.styleMaterial ? {
    control: styles => ({
      ...styles,
      ...styleMaterial,
      ...style,
      borderColor: error.show ? '#dc3545' : styles.borderColor,

    }),
    input: (provided, state) => ({
      ...provided,
      padding: 0,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: 6,
    }),
    indicatorSeparator:(provided, state) => ({
      ...provided,
      backgroundColor:"#fff"
    }),

  } :
    {
      control: styles => ({
        ...styles,
        ...style,
        borderColor: error.show ? '#dc3545' : styles.borderColor,

      }),
    }

  return (
    <>
      <Select
        {...props}
        options={options}
        value={selected}
        onChange={onChange}
        className={className}

        menuPortalTarget={document.querySelector('body')}
        styles={customStyles}
        ref={selectRef} // Using ref
      />
      {!props.disabled && (
        <input
          tabIndex={-1}
          autoComplete="off"
          value={_.isObject(value) && _.has(value, "value") && value['value'] ? value['value'] : value == null ? "" : value}
          style={{
            opacity: 0,
            width: "100%",
            height: 0,
            position: "absolute"
          }}
          onChange={noop}
          //  onFocus={() => this.selectRef.focus()}
          required={props.required}
        />
      )}
      {renderError()}
    </>
  )

}

InputSelect.defaultProps = {
  allNull: false,// can unselected all
  isMulti: false,// selected Multi
  required: false,
  className: "",
  validated: null,
  textFeedBack: "Required.",// display error when validation
  disabled: false,
  placeholder: "",
  styleMaterial: false,
}
export default InputSelect;

export { InputSelect };
